function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="110" height="110" fill="none" viewBox="0 0 24 24">
      <path
        fill="#0044F0"
        d="M10.153 5.556q.076.156.1.328l.278 4.14.138 2.081q.003.323.1.631c.167.397.568.649 1.005.631l6.657-.435c.289-.005.567.103.774.3.173.163.284.378.32.608l.011.14c-.275 3.815-3.077 6.997-6.884 7.818-3.806.821-7.71-.914-9.591-4.263a8.2 8.2 0 0 1-.997-3.146 6 6 0 0 1-.063-.986c-.006-4.09 2.906-7.626 6.983-8.478.491-.077.972.183 1.169.63"
      ></path>
      <path
        fill="#0044F0"
        d="M12.87 2c4.56.117 8.392 3.396 9.13 7.812l-.008.033-.02.047.003.13a.8.8 0 0 1-.192.473.83.83 0 0 1-.462.27l-.11.016-7.68.498a.92.92 0 0 1-.7-.227.88.88 0 0 1-.288-.537l-.516-7.67a.12.12 0 0 1 0-.08.79.79 0 0 1 .259-.555.82.82 0 0 1 .584-.21"
        opacity="0.4"
      ></path>
    </svg>
  );
}

export default Icon;
